/*
 * @Author: liyihui
 * @Date:
 * @description:  接口请求访问地址 企业信息相关内容
 * @Last Modified by:
 * @Last Modified time:
 */

import { mpFileRestGET, mpFileRestPOST, mpFileRestPUT, mpFileRestDEL } from './index';

// 获取压缩图片
function getSmallFile(data, func) {
	mpFileRestGET('file/' + data.fileName, data, func);
}

const API = {
	getSmallFile,
};

export default API;



// WEBPACK FOOTER //
// ./src/api/mpFileRest/upload.js